import { Component, OnDestroy, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { BreakpointObserver, Breakpoints } from "@angular/cdk/layout";
import { Store } from "@ngrx/store";
import { Subject } from "rxjs";
import { takeUntil } from "rxjs/operators";

import { LayoutService } from "../../../@core/utils";
import { Constant } from "../auth/constant/constant";
import { Logout } from "../auth/store/actions/authentication.actions";
import { AuthState } from "../auth/store/app.states";

@Component({
    selector: "ngx-header",
    styleUrls: ["./header.component.scss"],
    templateUrl: "./header.component.html",
    standalone: false
})
export class HeaderComponent implements OnInit, OnDestroy {

  private destroy$ = new Subject<void>();
  userPictureOnly = false;
  user: any;
  userInitials = "";

  constructor(
    private layoutService: LayoutService,
    private breakpointObserver: BreakpointObserver,
    private constant: Constant,
    private router: Router,
    private store: Store<AuthState>,
  ) {}

  ngOnInit() {
    const userInfo = JSON.parse(localStorage.getItem("authentication") || "{}");
    const profile = ((userInfo || {}).user || {}).profile || {};
    const first = ((profile.name || {}).first || "");
    const last = ((profile.name || {}).last || "");

    this.user = { name: (first + " " + last).trim() };
    this.userInitials = (first.charAt(0) + last.charAt(0)).toUpperCase();

    this.breakpointObserver
      .observe([Breakpoints.Handset, Breakpoints.TabletPortrait])
      .pipe(takeUntil(this.destroy$))
      .subscribe((result) => {
        this.userPictureOnly = result.matches;
      });
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

  toggleSidebar() {
    this.layoutService.toggleSidebar();
  }

  navigateToProfile() {
    this.router.navigateByUrl(this.constant.REDIRECT_LINKS.PROFILE);
  }

  logOut() {
    this.store.dispatch(new Logout());
  }

  goToDashboard() {
    this.router.navigateByUrl(this.constant.REDIRECT_LINKS.DASHBOARD);
  }
}
